import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectAccessSystemFilter } from 'shared/selectors/advancedFilters';

export const AccessSystemContainer: FC = () => {
  const { label, value, options } = useSelector(selectAccessSystemFilter);

  const onChange = useFilterChangeCallback();

  const handleAccessSystemChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setAccessSystem', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleAccessSystemChange} />
    </AdvancedFilterRow>
  );
};
